import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import DatamuseAssociation from "./DatamuseAssociation";
import DatamuseWildcard from "./DatamuseWildcard";

export default function DatamuseApiMain() {
    return (
        <Box sx={{ display: "flex", maxWidth: "md" }}>
            <Grid container spacing={2} sx={{ display: "flex", flexGrow: 1, height: "100%" }}>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h5" sx={{ mb: 2 }}>
                        Datamuse API
                    </Typography>
                </Grid>
                <Grid size={{ xs: 6 }}>
                    <DatamuseWildcard />
                </Grid>
                <Grid size={{ xs: 6 }}>
                    <DatamuseAssociation />
                </Grid>
            </Grid>
        </Box>
    );
}

